import { get } from "helpers/api_helper";

export const getProfileClinic = () => {
  return get("/master/account/");
};
